export default {"src":"/_next/static/media/mg.a6620514.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};